import { memo } from "react";

import { classNames } from "helpers";
import {
  RegistrationStatusTabProps,
  RegistrationStatusTabsProps,
} from "./types";

const StatusTab: React.FC<RegistrationStatusTabProps> = (props) => {
  const { value, label, count, active, dotClassName, onSelect } = props;

  const handleClick = () => {
    onSelect(value);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={classNames(
        "flex items-center gap-2 px-4 py-2 text-sm font-semibold border-b-2 -mb-px transition-colors whitespace-nowrap",
        active
          ? "border-sky-600 text-sky-600"
          : "border-transparent text-gray-500 hover:text-sky-600"
      )}
    >
      {dotClassName && (
        <span className={classNames("w-2 h-2 rounded-full", dotClassName)} />
      )}
      {label}
      <span
        className={classNames(
          "inline-flex items-center justify-center min-w-[20px] px-1.5 rounded-full text-xs font-medium",
          active ? "bg-sky-100 text-sky-700" : "bg-slate-100 text-slate-600"
        )}
      >
        {count}
      </span>
    </button>
  );
};

const RegistrationStatusTabs: React.FC<RegistrationStatusTabsProps> = (
  props
) => {
  const { activeStatus, summary, onStatusChange } = props;

  const tabs = [
    { value: "", label: "Svi", count: summary.total, dotClassName: undefined },
    {
      value: "expired",
      label: "Istekli",
      count: summary.expired,
      dotClassName: "bg-red-500",
    },
    {
      value: "expiring",
      label: "Pred istek",
      count: summary.expiring,
      dotClassName: "bg-yellow-400",
    },
    {
      value: "valid",
      label: "Važeći",
      count: summary.valid,
      dotClassName: "bg-green-500",
    },
  ];

  return (
    <div className="flex border-b border-slate-200 bg-white px-3">
      {tabs.map((tab) => (
        <StatusTab
          key={tab.value || "all"}
          value={tab.value}
          label={tab.label}
          count={tab.count}
          dotClassName={tab.dotClassName}
          active={(activeStatus ?? "") === tab.value}
          onSelect={onStatusChange}
        />
      ))}
    </div>
  );
};

export default memo(RegistrationStatusTabs);
